import { render, staticRenderFns } from "./OnionSummary.vue?vue&type=template&id=128302c9&scoped=true&"
import script from "./OnionSummary.vue?vue&type=script&lang=js&"
export * from "./OnionSummary.vue?vue&type=script&lang=js&"
import style0 from "./OnionSummary.vue?vue&type=style&index=0&id=128302c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128302c9",
  null
  
)

export default component.exports